import React, { useState } from "react";
import PropTypes from "prop-types";

import trashClosedIcon from "../../assets/brand/trash-closed.svg";
import trashOpenIcon from "../../assets/brand/trash-open.svg";

const SIZE_MAP = {
  xs: 14,
  sm: 20,
  md: 26,
  lg: 32,
  xl: 48,
};

const resolveSize = (size) => {
  if (typeof size === "string" && SIZE_MAP[size]) {
    return SIZE_MAP[size];
  }
  return size;
};

const TrashIcon = ({ size = "md", style, className = "", ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  const resolvedSize = resolveSize(size);

  return (
    <span
      className={`trash-icon-container ${className}`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        width: resolvedSize,
        height: resolvedSize,
        transition: "transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
        transform: isHovered ? "scale(1.1)" : "scale(1)",
        cursor: "pointer",
        ...style,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <img
        src={isHovered ? trashOpenIcon : trashClosedIcon}
        alt="delete"
        className="trash-icon-img"
        style={{
          width: resolvedSize,
          height: resolvedSize,
          display: "block",
        }}
      />
    </span>
  );
};

TrashIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  className: PropTypes.string,
};

export default TrashIcon;
